import { exitModalText, exitCovidMessages } from '../exitConfirmModal';

export default {
  // clear which flowName we should be using: booking, scheduling, appointment scheudling
  BOOKING_CONFIRM_DIALOG_TEXT: {
    ...exitModalText('Scheduling')
  },
  COVID_CONFIRM_DIALOG_TEXT: {
    ...exitCovidMessages('COVID Screening')
  }
};
